// @ts-check
import { Link } from '@material-ui/core';
import AppRouter from 'common/AppRouter';
import * as LighthouseService from 'common/services/lighthouse.service';
import { ARTICLE_IDS } from 'common/constants/constants';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import characterConnectProjects from 'images/characters/character-connect-projects.svg';
import { useHistory } from 'react-router';
import { LBButton } from '@linearb/buzz';

const EmptyState = ({ pmToolConfig }) => {
  const history = useHistory();
  return (
    <Flex
      pt='large'
      pb='x-large'
      direction='column'
      width='100%'
      items='center'
      justify='center'
    >
      <img src={characterConnectProjects} alt='' />
      <Flex items='center' pt='medium' pb='medium'>
        <Text size='medium' pr='0.3rem' color='shuttleGray'>
          Select the {pmToolConfig.entity_name_plural} your company is working
          on to edit your team settings
        </Text>
        <Text size='medium'>
          <Link
            onClick={() =>
              LighthouseService.navigateArticle(ARTICLE_IDS.CONNECT_PM)
            }
          >
            learn more
          </Link>
        </Text>
      </Flex>
      <LBButton
        variant='outline'
        size='lg'
        onClick={() => {
          history.push({
            pathname: `${AppRouter.PROJECT_MANAGEMENT.path}/${pmToolConfig.provider_path}`,
            search: 'isOrgSettings=true'
          });
        }}
      >
        Select company {pmToolConfig.entity_name_plural}
      </LBButton>
    </Flex>
  );
};
export default EmptyState;
